<script setup>
import RookieSortableItem from './RookieSortableItem.vue'

defineProps({
  day: {
    type: Object,
    required: true,
  },
  cdnUrl: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['remove'])
</script>

<template>
  <el-card style="margin-top: 5px" shadow="never" :header="`第${day.day}天`" v-loading="loading">
    <div class="rookie-drag-list">
      <RookieSortableItem
        v-for="(rookie, index) in day.images"
        :key="rookie.id"
        :rookie="rookie"
        :index="index"
        :group="`day-${day.day}`"
        :cdn-url="cdnUrl"
        @remove="$emit('remove', $event)"
      />
    </div>
  </el-card>
</template>

<style scoped>
.rookie-drag-list {
  display: flex;
  flex-wrap: wrap;
}
</style>
